import {
  GO_TO_ORDER_DETAILS_BUTTON_TYPE_NAME,
  REMOVE_LOCATION_BUTTON_TYPE_NAME,
  SHOW_COORDS_ON_MAP_BUTTON_TYPE_NAME,
  UPDATE_LOCATION_BUTTON_TYPE_NAME
} from '../data/constants/buttonsNamesConstants';
import { isNotEmptyArray, isNullOrEmptyString } from './utilsHelper';
import { getCopyToClipboardButton } from './htmlSnippets/tooltipSnippets.js';

export function getLocationMarkerTooltip(location) {
  if (location?.lat == null || location?.lon == null) return null;

  const lat = location.lat;
  const lon = location.lon;

  const copyCoordsButton = getCopyToClipboardButton(
    `${location?.id}:coords`,
    `lat='${lat}' lon='${lon}'`
  );
  const navigateButton = `<button clickable type='button' class="btn btn-white btn-xs ml-1" id='${SHOW_COORDS_ON_MAP_BUTTON_TYPE_NAME}:${location?.id}' lat='${lat}' lon='${lon}' click_action_type='${SHOW_COORDS_ON_MAP_BUTTON_TYPE_NAME}'><i class="fa fa-google" clickable_child></i></button>`;
  const coordsSection = `<div>${lat}, ${lon} ` + copyCoordsButton + navigateButton + '</div>';

  const tag = location?.oznaczenie ? '<b>' + location?.oznaczenie + '</b>' : '';
  const copyTagButton =
    tag === ''
      ? ''
      : getCopyToClipboardButton(`${location?.id}:tag`, `tag='${location.oznaczenie}'`);
  const tagSection = '<div>' + tag + copyTagButton + '</div>';

  const xid = location?.xid ? '<b>' + location?.xid + '</b>' : '';
  const copyXidButton =
    xid === '' ? '' : getCopyToClipboardButton(`${location?.id}:xid`, `xid='${location.xid}'`);
  const xidSection = '<div>' + xid + copyXidButton + '</div>';

  let noteSection = location.note ? `<div>Uwagi: <i>${location.note}</i></div>` : '';

  const editButton = `<button clickable type='button' class='btn btn-outline btn-info btn-xs' id='${UPDATE_LOCATION_BUTTON_TYPE_NAME}:${location?.id}' id_location='${location?.id}' click_action_type='${UPDATE_LOCATION_BUTTON_TYPE_NAME}'>Edytuj</button>`;
  const removeButton = `<button clickable type='button' class='btn btn-outline btn-danger btn-xs' id='${REMOVE_LOCATION_BUTTON_TYPE_NAME}:${location?.id}' id_location='${location?.id}' click_action_type='${REMOVE_LOCATION_BUTTON_TYPE_NAME}'>Usuń</button>`;
  const buttonsSection =
    `<div class='mt-1' style='display: flex; gap: 5px'>` + editButton + removeButton + '</div>';

  return (
    '<div style="display: flex; flex-direction: column; gap: 2px">' +
    coordsSection +
    tagSection +
    xidSection +
    noteSection +
    getTooltipWarningsSection(location) +
    buttonsSection +
    '</div>'
  );
}

function getTooltipWarningsSection(location) {
  if (location.warning_marker !== 1 || isNullOrEmptyString(location.warnings)) return '';

  const warningsArray = JSON.parse(location.warnings);
  if (!isNotEmptyArray(warningsArray)) return '';

  let warningsSection = '<div>Ostrzeżenia:';
  warningsSection += '<ol>';

  warningsArray.forEach((warning) => {
    warningsSection += `<li>${warning.message}`;

    if (warning.other_id_order != null) {
      warningsSection += getGoToOrderDetailsButtonHtml(location, warning);
    }

    warningsSection += '</li>';
  });
  warningsSection += '</ol></div>';

  return warningsSection;
}

function getGoToOrderDetailsButtonHtml(location, warning) {
  const orderId = warning?.other_id_order;
  const demPointId = warning?.other_id_dem_point;

  if (orderId == null) return '';

  return ` (<span class='fake-link' style='white-space: nowrap' clickable id='${GO_TO_ORDER_DETAILS_BUTTON_TYPE_NAME}:${location?.id}' id_order='${orderId}' id_demPoint='${demPointId}' click_action_type='${GO_TO_ORDER_DETAILS_BUTTON_TYPE_NAME}'>Zobacz zlecenie</span>)`;
}
